import { useState } from "react";
import { useMap } from 'ahooks';
import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/FmsTypes";
import { UserTypeEnum } from "@/types/FmsEnums";
import { useGlobalModel } from "@/model/globalModel";
import { transPgToPagination } from "@/views/base/app/appModel";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { contractManageService } from "@/views/contract/manage/ContractManageService";
import { ContractSummarySearch, ContractResult } from "@/views/contract/manage/ContractManageTypes";

export enum SummaryActionTypeEnum {
    CONTRACT,
    CUSTOMER
}
export const summaryModel = createModel(function () {
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    const { user: { shopCode } } = useGlobalModel();

    const [loading, setLoading] = useState(false)
    //查询条件
    const [searchParam, setSearchParam] = useState<ContractSummarySearch>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ContractResult[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>();
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<ContractResult[]>([]);
    //详情搜索key
    const [detailPartner, setDetailPartner] = useSessionStorageState<string>("contract.customer.detail.partner");

    //账户初始化
    const [initAccountVisible, setInitAccountVisible] = useState<boolean>(false);


    const updateSearchParam = (updateParam: ContractSummarySearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const resetSearchParam = () => {
        setSearchParam({});
        loadData(initPgCfg, {});
        setSelectedRowKeys([]);
        setSelectedData([]);
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ContractSummarySearch = searchParam) => {
        setLoading(true);
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            shopCode,
            partnerTypeCode: UserTypeEnum.CUSTOMER,
            page: {
                pageSize: page?.pageSize ?? pgCfg?.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg?.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }

        let { retData } = await contractManageService.customerSummaryPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);

        setLoading(false);
    }

    return {
        /***field***/
        loading,
        initPgCfg,
        searchParam,
        detailPartner,
        /***method***/
        dataSource, setDataSource,
        selectedRowKeys, setSelectedRowKeys,
        selectedData, setSelectedData,
        initAccountVisible, setInitAccountVisible,
        pgCfg,
        resetSearchParam,
        updateSearchParam,
        setDetailPartner,
        loadData,
    }
});
